import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-currency-icon',
  templateUrl: './currency-icon.component.html',
  styleUrls: ['./currency-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyIconComponent implements OnChanges {
  @Input({ required: true }) icon!: string;
  @Input() sizeCss = '--icon-medium';

  src = '';
  style: Record<string, string> = {
    color: 'var(--white-grey)',
    'font-size': 'var(--icon-medium)',
  };

  ngOnChanges(_changes: SimpleChanges): void {
    this.updateSrc();
    this.updateStyle();
  }

  private updateSrc(): void {
    this.src = `assets/images/currency/${this.icon}.svg`;
  }

  private updateStyle(): void {
    this.style = {
      'font-size': `var(${this.sizeCss})`,
    };
  }
}
